import React from "react";

import { makeStyles } from '@material-ui/core/styles';

import Button from "../../../../base/buttons/button.js";
import TextField from "../../../../base/inputs/text_field.js.jsx";
import HtmlContent from "../../../../base/components/html_content.js";

import I18n from "../../../../base/i18n.js.jsx";

import Routes from "../../../routes.js";

const blockStyles = makeStyles(theme => ({
  agreement: {
    fontSize: "12px",
    lineHeight: "1.4",
    margin: "8px 0 22px",
    ['@media (max-width: 768px)']: {
      margin: "12px 0 24px",
    },
  },
  button: {
    width: "100%",
    fontSize: "20px",
    padding: "12px 20px",
    ['@media (max-width: 768px)']: {
      fontSize: "18px",
      padding: "8px 20px",
    },
  },
  textField: {
    "& .MuiOutlinedInput-root": {
      borderColor: theme.palette.grayDisable,
    },
    "& .MuiOutlinedInput-root.Mui-focused": {
      borderColor: theme.palette.greenMain,
    },
    "& .MuiInputBase-input": {
      fontSize: "16px",
      padding: "10px 12px",
      ['@media (max-width: 768px)']: {
        fontSize: "14px",
        padding: "12px 16px",
      }
    }
  },
}));

const SubscribeBlock = props => {

  const classes = blockStyles();

  return (
    <div className = { classes.root }>
      <TextField value = { props.subscribeEmail } 
                 onChange = { props.onChangeEmail } 
                 className = { classes.textField }
                 name = { "email" }
                 displayNamePosition =  { "above" } 
                 placeholder = { I18n.t("web.subscription.email") }/>
      <HtmlContent className = { classes.agreement } >
        { I18n.t("web.subscription.agreement", {data_protection: Routes.dataProtection()}) }
      </HtmlContent>
      <Button type = { "submit" }
              className = { classes.button } 
              disabled = { props.submitting } >
              { I18n.t("action.subscribe") }
      </Button>
    </div>
  )
}

export default SubscribeBlock